<template>
  <div class="main-page-container module-index-container">
    <div v-show="!collapsed" class="module-index">
      <template v-for="twoMenu in getTwoMenus">
        <ChildBtn :key="twoMenu.name" :two-menu="twoMenu"></ChildBtn>
      </template>
    </div>
    <router-view v-show="collapsed"></router-view>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
export default {
  props: {
  },
  data() {
    return {
    };
  },
  computed:{
    ...mapState(['collapsed', 'activeOne']),
    ...mapGetters(['getTwoMenus']),
  },
  mounted(){
  },
  methods:{
  }
};
</script>
<style lang="less" scoped>
.module-index-container{
    overflow: auto;
  }
.layout-2{
  .module-index-container{
    display: flex;
    align-items: flex-end;
  }
}
</style>
